module.exports = __webpack_public_path__ + "b3inventory.b5209d7a5f1387877932.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/yardobject/font/b3inventory.ttf?14714644
// module id = 897
// module chunks = 3